import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import { memo } from 'react'
import { Doughnut } from 'react-chartjs-2'

import { parseNumber } from '../utils/display'
import DataNotFound from './DataNotFound'

ChartJS.register(ArcElement, Tooltip, Legend)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const label = (tooltipItem: any) => {
  let sum = 0
  tooltipItem.dataset.data.forEach((val: number) => {
    sum += val
  })
  const ratio = Math.round((tooltipItem.raw / sum) * 100)
  return `${parseNumber(tooltipItem.raw)}人 (${ratio >= 1 ? ratio : 1}% ${ratio >= 1 ? '' : '未満'})`
}

interface LabelData {
  id: string;
  label: string;
  value: number;
}

interface DoughnutChartProps {
  labelData: LabelData[];
}

const DoughnutChart = memo(({ labelData }: DoughnutChartProps) => {
  if (labelData.every((d) => d.value === 0)) {
    return <DataNotFound className='min-h-[33vh]' />
  }

  const data = {
    labels: labelData.map((d) => d.label),
    datasets: [
      {
        label: '',
        data: labelData.map((d) => d.value),
        backgroundColor: ['#006600', '#009900', '#00CC00', '#33FF33', '#66FF66', '#99FF99', '#CCFFCC', '#DCDBDB'],
        borderColor: ['#006600', '#009900', '#00CC00', '#33FF33', '#66FF66', '#99FF99', '#CCFFCC', '#DCDBDB'],
        borderWidth: 1,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        displayColors: false,
        callbacks: { label },
      },
      legend: {
        display: false,
        position: 'right' as const,
        align: 'center' as const,
        labels: {
          boxWidth: 15,
          boxHeight: 15,
        },
      },
      title: {
        display: false,
      },
    },
    cutout: '40%',
    radius: '80%',
  }

  return (
    <div className="flex items-center justify-start">
      <Doughnut className='max-h-[33vh] max-w-[70%]' data={data} options={options} />
      <div className="ml-4 text-xs">
        {labelData.map(({ id, label: labelText, value }, index) => (
          <div key={id} className="flex items-center mb-2">
            <div
              className="w-3 h-3 mr-1"
              style={{ backgroundColor: data.datasets[0].backgroundColor[index] }}
            />
            <span>{labelText}: {parseNumber(value)}人</span>
          </div>
        ))}
      </div>
    </div>
  )
})

export default DoughnutChart